<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Exchange Rates</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4>
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            class="ma-0"
            :outlined="outlinedInputs"
            v-model="search"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              dark
              color="primary"
              @click="onCreate"
              class="ma-2"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Exchange Rate</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="id"
        >
          <template v-slot:item.dateFrom="{ item }">{{
            item.dateFrom | formatDate
          }}</template>
          <template v-slot:item.dateTo="{ item }">{{
            item.dateTo | formatDate
          }}</template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="onDeleteItem"
              @editItem="editItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-card>
      <exchange-rate-edit-dialog
        v-model="editedExchangeRate"
        :show="showEditDialog"
        @close="showEditDialog = false"
        @input="onSave"
      ></exchange-rate-edit-dialog>
      <get-more-results
        :first="first"
        @limitChange="onLimitChange"
        :items="exchangeRates"
        :totalItems="totalItems"
        :loading="$apollo.loading"
        :loadMoreEnabled="loadMoreEnabled"
        @loadMore="loadMore('exchangeRates')"
      ></get-more-results>
    </v-flex>
    <div v-if="debug">
      {{ items.length }}
      {{ exchangeRates ? exchangeRates.edges.length : 0 }}
    </div>
  </v-layout>
</template>

<script>
import {
  ALL_EXCHANGE_RATES_SEARCH_QUERY,
  EXCHANGE_RATE_DELETE_MUTATION,
  EXCHANGE_RATE_UPDATE_MUTATION,
  EXCHANGE_RATE_CREATE_MUTATION,
} from "../../../../constants/graphql";

import DefaultListActions from "../../shared/DefaultListActions";
import { ListMixin } from "../../../../mixins/ListMixin";
import {
  sortByDate,
  pagingOptions,
  removeGQLTypename,
} from "../../../../helpers/index";
import ExchangeRateEditDialog from "./ExchangeRateEditDialog";
import GetMoreResults from "../../shared/GetMoreResults";
const moment = require("moment");

export default {
  name: "ExchangeRatesList",

  mixins: [ListMixin],

  components: {
    DefaultListActions,
    ExchangeRateEditDialog,
    GetMoreResults,
  },

  data() {
    return {
      debug: false,
      pagingOptions,
      first: 250,
      pageSize: 250,
      editedExchangeRate: {},
      search: "",
      showEditDialog: false,
      headers: [
        {
          text: "Currency Code",
          align: "left",
          value: "currencyCode",
          name: "currencyCode",
        },
        {
          text: "Rate",
          align: "left",
          value: "rate",
          name: "rate",
        },
        {
          text: "From",
          align: "left",
          value: "dateFrom",
          type: "date",
          name: "dateFrom",
          sort: sortByDate,
        },
        {
          text: "To",
          align: "left",
          value: "dateTo",
          type: "date",
          name: "dateTo",
          sort: sortByDate,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    items() {
      return this.exchangeRates && this.exchangeRates.edges
        ? this.exchangeRates.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    editItem(item) {
      this.editedExchangeRate = { ...item };
      this.showEditDialog = true;
    },
    onCreate() {
      this.editedExchangeRate = {};
      this.showEditDialog = true;
    },
    async onSave(payload) {
      this.showEditDialog = false;
      const { id, ...input } = payload;
      const mutation = payload.id
        ? EXCHANGE_RATE_UPDATE_MUTATION
        : EXCHANGE_RATE_CREATE_MUTATION;
      try {
        const mutationRes = await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: { ...input }, id },
          refetchQueries: [
            {
              query: ALL_EXCHANGE_RATES_SEARCH_QUERY,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Exchange Rate  Saved.",
        });
      } catch (error) {
        console.log(error);
      }
    },
    async onDeleteItem(payload) {
      try {
        await this.$apollo.mutate({
          mutation: EXCHANGE_RATE_DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: ALL_EXCHANGE_RATES_SEARCH_QUERY,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Business Model deleted",
        });
      } catch (error) {
        console.log(error);
      }
    },
  },

  apollo: {
    exchangeRates: {
      query: ALL_EXCHANGE_RATES_SEARCH_QUERY,

      result({ data, loader, networkStatus }) {
        this.totalItems = data.exchangeRates.totalCount;
        //  this.pagination.totalItems = data.itineraries.totalCount;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/currencies/ExchangeRatesList.vue